var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-campaign text-3xl"},[_vm._v("ไม่พบ Campaign")])}
var staticRenderFns = []

export { render, staticRenderFns }